import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';

export class ApplicationSoleOwnerItem {

    form: FormGroup;

    constructor(private formBuilder: FormBuilder, private authService: AuthService) {
        this.form = this.formBuilder.group({
            authorize: ['false', Validators.required],
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            mobilePhoneNumber: ['', Validators.required],
            emailAddress: ['', [Validators.required, Validators.email]],
            birthDate: ['', Validators.required],
            socialSecurityNumber: ['', Validators.required],
            doingBusinessAs: ['', Validators.required],
            businessStartDate: ['', Validators.required],
            homeAddress: ['', Validators.required],
            zipCode: ['', Validators.required],
            city: ['City Value', Validators.required],
            state: ['State value', Validators.required],
            county: ['', Validators.required],
            sameAsBusiness: ['true'],
            businessAddress: ['', Validators.required],
            businessZip: ['', Validators.required],
            businessCity: ['', Validators.required],
            businessState: ['', Validators.required],
            businessCounty: ['', Validators.required],
            requestedAmount: ['', [Validators.required, Validators.min(500)]],
            equipmentDescription: [''],
            creditAuth: ['false'],
            creditAuthTwo: ['false'],
            businessType: ['', Validators.required],
            ownershipPercentage: ['', Validators.required],
            taxId: ['']
        });

        this.authService.maxApplicationAmount.then(
            (data: number) => {
                this.form.controls.requestedAmount.setValidators(data ? [Validators.required, Validators.max(data), Validators.min(500)] : [Validators.required, Validators.min(500)]);
                this.form.controls.requestedAmount.updateValueAndValidity();
            }
        );
    }

    decode(data: any) {
        this.form.controls.authorize.setValue(data.primaryOwner ? 'true' : 'false');
        this.form.controls.firstName.setValue(data.firstName);
        this.form.controls.lastName.setValue(data.lastName);
        this.form.controls.mobilePhoneNumber.setValue(data.mobilePhoneNumber);
        this.form.controls.emailAddress.setValue(data.email);
        this.form.controls.birthDate.setValue(data.birthDate);
        this.form.controls.socialSecurityNumber.setValue(data.socialSecurityNumber);
        this.form.controls.doingBusinessAs.setValue(data.dbaName);
        this.form.controls.businessStartDate.setValue(data.businessPurchaseDate);
        this.form.controls.homeAddress.setValue(data.streetAddress);
        this.form.controls.zipCode.setValue(data.zipCode);
        this.form.controls.city.setValue(data.city);
        this.form.controls.state.setValue(data.state);
        this.form.controls.county.setValue(data.county);
        this.form.controls.sameAsBusiness.setValue(data.sameAsBusiness ? 'true' : 'false');
        this.form.controls.businessAddress.setValue(data.businessAddress);
        this.form.controls.businessZip.setValue(data.businessZip);
        this.form.controls.businessCity.setValue(data.businessCity);
        this.form.controls.businessState.setValue(data.businessState);
        this.form.controls.businessCounty.setValue(data.businessCounty);
        this.form.controls.requestedAmount.setValue(data.requestedAmount);
        this.form.controls.equipmentDescription.setValue(data.description);
        this.form.controls.creditAuth.setValue(data.creditAuth);
        this.form.controls.creditAuthTwo.setValue(data.creditAuthTwo);
    }

    encode(): any {
        return {
            'description': this.form.controls.equipmentDescription.value,
            'requestedAmount': this.form.controls.requestedAmount.value,
            'lessee': {
                'legalName': `${this.form.controls.firstName.value} ${this.form.controls.lastName.value}`,
                'dbaName': `${this.form.controls.firstName.value} ${this.form.controls.lastName.value}`,
                'email': this.form.controls.emailAddress.value,
                'address': this.form.controls.businessAddress.value,
                'zipCode': this.form.controls.businessZip.value,
                'state': this.form.controls.businessState.value,
                'city': this.form.controls.businessCity.value,
                'county': this.form.controls.businessCounty.value,
                'businessStructure': this.form.controls.businessType.value,
                'businessPurchaseDate': this.getFormatedDate(this.form.controls.businessStartDate.value),
                'phoneNumber': this.form.controls.mobilePhoneNumber.value,
                'federalTaxId': this.form.controls.taxId.value,
                'owners': [{
                    'firstName': this.form.controls.firstName.value,
                    'lastName': this.form.controls.lastName.value,
                    'mobilePhoneNumber': this.form.controls.mobilePhoneNumber.value,
                    'email': this.form.controls.emailAddress.value,
                    'birthDate': this.getFormatedDate(this.form.controls.birthDate.value),
                    'socialSecurityNumber': this.form.controls.socialSecurityNumber.value,
                    'streetAddress': this.form.controls.homeAddress.value,
                    'zipcode': this.form.controls.zipCode.value,
                    'city': this.form.controls.city.value,
                    'state': this.form.controls.state.value,
                    'primaryOwner': this.form.controls.authorize.value,
                    'creditAuth': this.form.controls.creditAuth.value,
                    'creditAuthTwo': this.form.controls.creditAuthTwo.value,
                    'ownershipPercentage': this.form.controls.ownershipPercentage.value
                }]
            }
        };
    }

    getFormatedDate(date: any): string {
        const year = date.getFullYear();
        const month = date.getMonth() > 8 ? '-' + (date.getMonth() + 1) : '-0' + (date.getMonth() + 1);
        const day = date.getDate() > 9 ? '-' + date.getDate() : '-0' + date.getDate();
        return year + month + day;
    }

    get oForm() { return this.form.controls; }

    setDefaultData(pOwnershipPercentage?: number) {
        const currentTime = (new Date()).getTime().toString();

        this.decode({
            primaryOwner: true,
            firstName: 'Jane',
            lastName: 'Doe',
            mobilePhoneNumber: '3219780000',
            email: 'me@mail.com',
            birthDate: new Date(1990, 0, 1),
            socialSecurityNumber: currentTime.substr(currentTime.length - 9),
            dbaName: 'My DBA Name',
            businessPurchaseDate: new Date(2016, 0, 1),
            streetAddress: '1182 Main St',
            zipCode: '84105',
            city: 'Salt Lake City'.toUpperCase(),
            state: 'UT',
            county: 'Salt Lake'.toUpperCase(),
            sameAsBusiness: true,
            businessAddress: '1182 Main St',
            businessZip: '84105',
            businessCity: 'Salt Lake City'.toUpperCase(),
            businessState: 'UT',
            businessCounty: 'Salt Lake'.toUpperCase(),
            requestedAmount: 15000,
            description: 'Demo Test Equipment',
            creditAuth: true,
            creditAuthTwo: false
        });
    }
}
